import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ColorSchemes from 'mangools-commons/dist/constants/ColorSchemes';
import DOMService from 'mangools-commons/dist/services/DOMService';
import { readSharedColorScheme, writeSharedColorScheme } from 'mangools-commons/dist/services/ColorSchemeService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IconProp } from '@fortawesome/fontawesome-svg-core';

const AUTO_THEME = 'Auto';

type SwitchMapProps = {
  [key: string]: {
    next: () => void;
    icon: IconProp;
    title: string;
    text: string;
  };
};

const colorSchemeSelector = (state: any) => state.ui.misc.colorScheme;

const setColorScheme = (payload: any) => ({
  type: 'UI_MISC_COLOR_SCHEME_SET',
  payload,
});

const DarkModeToggle = () => {
  const dispatch = useDispatch();
  const colorScheme = useSelector(state => colorSchemeSelector(state));
  const hasMatchMedia = DOMService.hasMatchMedia();

  useEffect(() => {
    const savedColorScheme = readSharedColorScheme();
    if (savedColorScheme) {
      dispatch(setColorScheme(savedColorScheme));
      writeSharedColorScheme(savedColorScheme);
    }
  }, [dispatch]);

  const switchMap = {
    [ColorSchemes.LIGHT]: {
      next: () => {
        dispatch(setColorScheme(ColorSchemes.DARK));
        writeSharedColorScheme(ColorSchemes.DARK);
      },
      icon: 'sun',
      title: 'Switch to dark theme',
      text: 'Light',
    },
    [ColorSchemes.DARK]: {
      next: hasMatchMedia
        ? () => {
          dispatch(setColorScheme(ColorSchemes.AUTO));
          writeSharedColorScheme(ColorSchemes.AUTO);
        }
        : () => {
          dispatch(setColorScheme(ColorSchemes.LIGHT));
          writeSharedColorScheme(ColorSchemes.LIGHT);
        },
      icon: 'moon',
      title: `Switch to ${hasMatchMedia ? 'auto' : 'light theme'}`,
      text: 'Dark',
    },
    [ColorSchemes.AUTO]: {
      next: () => {
        dispatch(setColorScheme(ColorSchemes.LIGHT));
        writeSharedColorScheme(ColorSchemes.LIGHT);
      },
      icon: ['fac', 'moon-auto'],
      title: 'Switch to light theme',
      text: AUTO_THEME,
    },
  } as SwitchMapProps;

  const activeScheme = switchMap[colorScheme] ?? switchMap[ColorSchemes.LIGHT];

  return (
    <button
      type="button"
      onClick={activeScheme.next}
      title={activeScheme.title}
    >
      <FontAwesomeIcon
        icon={activeScheme.icon}
        aria-label="Theme toggle"
        className="uk-position-relative"
        style={activeScheme.text === AUTO_THEME ? { left: '-2px' } : undefined}
      />
    </button>
  );
};

export default DarkModeToggle;
